import type {
  FormErrors,
  FormInputType,
  FormOnValidate,
  FormValues,
} from '@/components/UI/Form/types'

const ATTENDANCE_POLICY_CONFIRM = 'I understand'
const ATTENDANCE_POLICY_ERROR_MESSAGE = `Please type "${ATTENDANCE_POLICY_CONFIRM}" exactly to confirm the attendance policy.`

export function getSessionRegistrationOnValidate({
  requiredAttendance,
}: {
  requiredAttendance: boolean
}): FormOnValidate {
  const onValidate: FormOnValidate = (values: FormValues, _errors: FormErrors | null) => {
    if (!requiredAttendance) {
      return null
    }
    if (
      !(
        `${values.attendance_policy_text}`.toLowerCase().trim() ===
        ATTENDANCE_POLICY_CONFIRM.toLowerCase()
      )
    ) {
      return {
        errors: { attendance_policy_text: ATTENDANCE_POLICY_ERROR_MESSAGE },
        message: ATTENDANCE_POLICY_ERROR_MESSAGE,
      }
    }
    return null
  }
  return onValidate
}

export default function getSessionRegistrationFormInputs({
  sessionQuestionnaire,
  worldTitleToRegisterFor: _,
  requiredAttendance,
  onlyShowQuestionnaire = false,
}: {
  sessionQuestionnaire: FormInputType[] | null
  worldTitleToRegisterFor: string | null
  requiredAttendance: boolean
  onlyShowQuestionnaire?: boolean
}): FormInputType[] {
  if (onlyShowQuestionnaire) {
    return sessionQuestionnaire ?? []
  }

  const attendancePolicyFormInput: FormInputType = requiredAttendance
    ? {
        type: 'text',
        name: 'attendance_policy_text',
        label: `This session has required attendance. If you are unable to attend, please make sure to unregister, as multiple unexcused absences may lead to a
          suspension of your Schoolhouse account. Type "${ATTENDANCE_POLICY_CONFIRM}" to acknowledge this policy before registering.`,
        required: true,
        placeholder: ATTENDANCE_POLICY_CONFIRM,
        size: 6,
      }
    : {
        type: 'multi-checkbox',
        name: 'attendance_policy',
        label: `This session takes place virtually on Zoom. If later you are unable to attend
		this session, please make sure to unregister.`,
        options: [
          {
            value: 'accepted_attendance_policy',
            label: 'Yes, I have read and acknowledged the session attendance policy.',
          },
        ],
        required: true,
        size: 6,
      }

  return [...(sessionQuestionnaire ?? []), attendancePolicyFormInput]
}
